import { Controller } from "@hotwired/stimulus"

// Settle glow for a freshly-arrived insight card. When the broadcaster
// swaps an `insight_tile_<agent>` skeleton with the rendered card,
// `_card_shell.html.erb` paints `data-controller="insight-glow"` so this
// controller mounts. It adds the `insight-glow-active` class for ~1.2s
// to drive the keyframed glow, then removes the controller so future
// re-renders don't replay the animation.
//
// Pair with the `@keyframes insight-glow-pulse` rule in
// `app/assets/stylesheets/custom.css`.
export default class extends Controller {
  connect() {
    console.log("[insight-glow] connect — playing 1s settle animation")
    this.element.classList.add("insight-glow-active")
    this.timeout = setTimeout(() => {
      this.element.classList.remove("insight-glow-active", "insight-glow")
      this.element.removeAttribute("data-controller")
    }, 1200)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
